import Api from "app/services/common/Api";
import {ApiUrlUtil} from "app/utils/apiUrlUtil";
import {WorkSearchModel} from "app/model/work/workElectricModel";
import {CoSearchModel} from "app/model/common/coModel";
import {
  ElecUsageStatusAgg,
  EngUseStatusModel,
  PdcsGasEmsnBodyReturn,
  PdcsGasEmsnHeaderData,
  PdcsSplycsDataModel,
  PdcsSplycsStaticsModel
} from "app/model/mg/pwrModel";
import {
  BsnBusiness,
  BsnElecDay,
  BsnElecHour,
  BsnElecMonth,
  BsnGhgsData, BsnSolarAgg, BsnSolarData,
  BsnStatPwrUse
} from "app/model/pdcs/bsnStatus";
import { SolarGenData, SolarGenDataSearch, SolarGenStat } from "app/model/pdcs/solarGen";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { HeadersUtil } from "app/utils/headersUtil";
import { ResponseTui } from "app/model/response-tui";

export class PcAdminService extends Api {
  private static service: PcAdminService;

  public static getInstance(): PcAdminService {
    if (!PcAdminService.service) {
      PcAdminService.service = new PcAdminService();
    }
    return PcAdminService.service;
  }
  
  // 관리자 - 생산소비

  public getEmissionStatistics() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/ess/statistics");
    return super.get<any>(url);
  }

  public getEssPwrStatus() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/ess/status");
    return super.get<any>(url);
  }

  // 관리자 > 수용가 현황 > 사업장 조회 : 단지코드로 해당 단지에 속한 사업장 목록 호출
  public getCustDetailsOfComplex(complex:string,) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pdcs/bsnstatus/custs?searchIndsCmplxClCd=${complex}`);
    return super.get<BsnBusiness[]>(url);
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 전력 사용량 : 선택된 사업장의 금일/금월/금년 전력 사용량 호출
  public getPwrUseAggOfCust(kepcoCustNo:string, fromDt:string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pdcs/bsnstatus/cust/pwr/use/agg?searchKepcoCustNo=${kepcoCustNo}&fromDt=${fromDt}`);
    return super.get<BsnStatPwrUse>(url);
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 전력 사용량 : 시간별 공급/소비 전력 호출(yyyyMMdd)
  public getPwrUseAndGenByHourOfCust(kepcoCustNo:string, fromDt:string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pdcs/bsnstatus/cust/pwr/use/gen/hour';
    return super.get<BsnElecHour[]>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 전력 사용량 : 일별 공급/소비 전력 호출(yyyyMM)
  public getPwrUseAndGenByDayOfCust(kepcoCustNo:string, fromDt:string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pdcs/bsnstatus/cust/pwr/use/gen/day';
    return super.get<BsnElecDay[]>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 전력 사용량 : 월별 공급/소비 전력 호출(yyyy)
  public getPwrUseAndGenByMonthOfCust(kepcoCustNo:string, fromDt:string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pdcs/bsnstatus/cust/pwr/use/gen/month';
    return super.get<BsnElecMonth[]>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 온실가스 배출량 : 선택된 사업장의 금일 온실가스 배출량 호출
  public getGhgsEmsnAggDayOfCust(kepcoCustNo: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/gas/dischargstatus/kepco/statistics';
    return super.get<number[]>(url, { searchKepcoCustNo: kepcoCustNo });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 온실가스 배출량 : 선택된 사업장의 금월/금년 온실가스 배출량 호출
  // public getGhgsEmsnAggOfCust(kepcoCustNo: string) {
  //   const url: string = process.env.REACT_APP_URL_CP + '/EmissionsStatus/emsn/kepco/statistics';
  //   return super.get<{month: number; year: number;}>(url, { searchKepcoCustNo: kepcoCustNo });
  // }

  // 관리자 > 수용가 현황 > 사업장 조회 > 온실가스 배출량 : 시간별 온실가스 배출량 호출(**yyyyMMdd)
  public getGhgsEmsnByHourOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/gas/dischargstatus/kepco';
    return super.get<BsnGhgsData[]>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt.substring(0, 8)});
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 온실가스 배출량 : 일별 온실가스 배출량 호출(**yyyyMM)
  public getGhgsEmsnByDayOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/gas/dischargstatus/kepco';
    return super.get<BsnGhgsData[]>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt.substring(0, 6)});
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 온실가스 배출량 : 월별 온실가스 배출량 호출(yyyy)
  public getGhgsEmsnByMonthOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/gas/dischargstatus/kepco';
    return super.get<BsnGhgsData[]>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt.substring(0,4) });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 태양광 발전량 : 선택된 사업장의 금일/금월/금년 태양광 발전량 호출
  public getSolarGenAggOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pdcs/bsnstatus/cust/pv/gen/agg';
    return super.get<BsnSolarAgg>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 태양광 발전량 : 시간별 태양광 발전량 호출(**yyyyMMdd)
  public getSolarByHourOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/renewal/solar';
    return super.get<BsnSolarData>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 태양광 발전량 : 일별 태양광 발전량 호출(**yyyyMMdd)
  public getSolarByDayOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/renewal/solar';
    return super.get<BsnSolarData>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt, searchType: 'DAY' });
  }

  // 관리자 > 수용가 현황 > 사업장 조회 > 태양광 발전량 : 월별 태양광 발전량 호출(**yyyyMMdd)
  public getSolarByMonthOfCust(kepcoCustNo: string, fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/pc/renewal/solar';
    return super.get<BsnSolarData>(url, { searchKepcoCustNo: kepcoCustNo, fromDt: fromDt, searchType: 'MONTH' });
  }

  public getPwrGenByPvOfCust(kepcoCustNo:string, fromDt:string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pdcs/bsnstatus/cust/pv/gen?searchKepcoCustNo=${kepcoCustNo}&fromDt=${fromDt}`);
    return super.get<any>(url);
  }
  public getPwrUseByFclOfCust(kepcoCustNo:string, fromDt:string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pdcs/bsnstatus/cust/fcl/use?searchKepcoCustNo=${kepcoCustNo}&fromDt=${fromDt}`);
    return super.get<any>(url);
  }

  public getGasemistatus(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pdcs/gasemistatus", search);
    return super.get<any>(url);
  }

  /**
   * 관리자 > 전력 사용 현황 > 상단 정보 박스 데이터
   */
  public async getEngUseAggStatusByComplex(search: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + '/pdcs/engusestatus/agg';
    return super.get<ElecUsageStatusAgg>(url, search);
  }

  public getEngUseStatus(search: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + '/pdcs/engusestatus';
    return super.get<EngUseStatusModel[]>(url, search);
  }

  /**
   * 관리자 > 전력 사용 현황 > 사업장 목록 데이터
   */
  public async getEngUseStatusByOffset(search: CoSearchModel, cancelApi?: AbortSignal): Promise<ResponseTui> {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + '/pdcs/engusestatus', search);

    let config: AxiosRequestConfig = { headers: HeadersUtil.getHeadersAuth() };
    if (cancelApi) {
      config = { ...config, signal: cancelApi };
    }

    const response: AxiosResponse<ResponseTui> =
      await axios.get<ResponseTui>(url, config);
    if (response && response.data) {
      return response.data ?? { result: true, data: { contents: [], pagination: { page: 1, totalCount: 0 }}};
    }
    return { result: false, data: { contents: [], pagination: { page: 1, totalCount: 0 }} };
  }

  public getPwrGenPvByComplex(fromDt:string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/ic/gas/erstatistics/all/pwr/gen/complex?fromDt=${fromDt}`);
    return super.get<any>(url);
  }
  public getPwrGenPvByBzknd(fromDt:string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/work/ghgs/stat/pv/pwr/gen/bzknd?fromDt=${fromDt}`);
    return super.get<any>(url);
  }

  // 관리자 > 신재생 현황 > 단지별 조회 > 발전량 조회 : 현재/오늘/금월/누적 발전량 호출
  public getSolarStatistics(indsCmplxClCd: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pc/renewal/solar/statistics`);
    return super.get<Array<SolarGenStat|null>>(url, { searchIndsCmplxClCd: indsCmplxClCd });
  }

  // 관리자 > 신재생 현황 > 단지별 조회 > 발전량 조회 : 기간별 발전 현황 호출
  public async getSolarData(param: SolarGenDataSearch) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/solar");
    return await super.get<SolarGenData>(url, param);
  }

  public getFacilityStatistics () {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pdcs/facility/statistics`);
    return super.get<any>(url);
  }

  public getFacilityStatisticsCard (form:any) {
    let param: Record<string, string> = {};
    if (form.text) {
      param.searchCsthsNm = form.text;
    }

    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pdcs/facility/status`);
    return super.get<any>(url, param);
  }

  public getSplycsStatistics(search: Pick<CoSearchModel, 'searchType'|'fromDt'|'searchIndsCmplxClCd'>) {
    const url = process.env.REACT_APP_URL_CO + '/pdcs/splycs/statistics';
    return super.get<PdcsSplycsStaticsModel>(url, search);
  }

  public async getSplycsData(param: any) {
    const url = process.env.REACT_APP_URL_CO + "/pdcs/splycs/data";
    return await super.get<PdcsSplycsDataModel[]>(url, param);
  }

  // 생산소비현황 > 온실가스배출량 > 전력사용 배출량 조회 > 헤더
  public async getPdcsGasEmissionHeader(indsCmplxClCd: string) {
    const url = process.env.REACT_APP_URL_CO + '/pc/gas/dischargstatus/statistics';
    return super.get<PdcsGasEmsnHeaderData>(url, { searchIndsCmplxClCd: indsCmplxClCd });
  }

  // 생산소비현황 > 온실가스배출량 > 전력사용 배출량 조회 > 차트&그리드
  public async getPdcsGasEmission(param: WorkSearchModel) {
    const url = process.env.REACT_APP_URL_CO + '/pdcs/gasemission';
    return super.get<PdcsGasEmsnBodyReturn[]>(url, param);
  }

  /**
   * @deprecated
   */
  public async getPwrStationGen() {
    const url = process.env.REACT_APP_URL_CO + '/pdcs/pwrStation/gen';
    return super.get<any>(url);
  }
}